export const onlyNumbers = (value: string): string => {
  return value.replace(/[^\d]/g, '');
};

export const accountWithDigitMask = (value: string) => {
  const onlyNumbersValue = onlyNumbers(value);
  return onlyNumbersValue.length < 2 ? onlyNumbersValue : onlyNumbers(value).slice(0, -1) + '-' + onlyNumbers(value).slice(-1);
}